

/// <reference path="LocalizedEntity.ts" />

// Generated class ManagerSectionLocalized_ManagedObject

class ManagerSectionLocalized_ManagedObject extends LocalizedEntity
{

    // Property: module
    set module(value:string) {
        this.setValueForKey(value, 'module');
    }
    get module():string {
        return this.valueForKey('module');
    }
    set modulePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'module');
    }
    get modulePrimitiveValue():string {
        return this.primitiveValueForKey('module');
    }

    // Property: name
    set name(value:string) {
        this.setValueForKey(value, 'name');
    }
    get name():string {
        return this.valueForKey('name');
    }
    set namePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'name');
    }
    get namePrimitiveValue():string {
        return this.primitiveValueForKey('name');
    }
    // Relationship: managerSection
    set managerSection(value:ManagerSection) {
        this.setValueForKey(value, 'managerSection');
    }
    get managerSection():ManagerSection {
        return this.valueForKey('managerSection') as ManagerSection;
    }
}
